export const EPOCH_J1900 = 2415020.0;
export const EPOCH_J1950 = 2433282.5;
export const EPOCH_J2000 = 2451545.0;
export const EPOCH_J2100 = 2488070.0;
